import {
  INIT_BUYCART,
  ADD_CART,
  GET_USERINFO,
  RECORD_USERINFO,
  ADD_ANIMATION,
  SHOW_CART,
  REDUCE_CART,
  EDIT_CART,
  GET_PRODUCTCATEGORYLIST,
  INFO_CART,
  SITE_LIST,
  NEWS_ID,
  SEARCH_LIST,
  COMPANY_CODE,
  COMPANY_ID,
  COMPANY_NAME,
  GUESS_PRODUCTS,
  SEARCH_WORD,
  CHANGE_ITEM,
  GETCUSTOMER,
  CHANGE_USERINFO,
  GET_PRODUCTCATEGORYLISTNOLOGIN,
  PRODUCT_LIST,
  PRODUCT_LIST_1,
  PRODUCT_LIST_2,
  CATEGORY_LIST,
  PRODUCT_INFO,
  TABLE_LIST,
  HADNDLE_COLLAPSE,
  BRAND_INfO,
  CREATE_PRODUCT_LIST,
  GET_LOGO_IMG_LIST,
  IS_SHOW_RIGHT_BAR,
  SHOW_LIB,
  ROUTER_PARAMS,
  IS_PROTOCOL,
} from './mutation-types';
import { setStore, getStore } from '../utils/storage';

export default {
  // NEWS_ID
  [NEWS_ID](state, payload) {
    state.newsId = payload;
  },
  // 网页初始化时从本地缓存获取购物车数据
  [INIT_BUYCART](state) {
    const initCart = getStore('buyCart');
    if (initCart) {
      state.cartInfo = JSON.parse(initCart);
    }
  },
  // 获取搜索列表
  [SEARCH_LIST](state, payload) {
    state.searchData = payload;
  },
  // 获取搜索列表
  [SEARCH_WORD](state, payload) {
    state.searchWord = payload;
  },
  // 获取公司编码
  [COMPANY_CODE](state, payload) {
    state.companyCode = payload;
  },
  // 获取公司ID
  [COMPANY_ID](state, payload) {
    state.companyId = payload;
  },
  // 获取公司编码
  [COMPANY_NAME](state, payload) {
    state.companyName = payload;
  },
  // 获取猜你喜欢
  [GUESS_PRODUCTS](state, payload) {
    state.guessProducts = payload;
  },
  // 加入购物车
  [ADD_CART](
    state,
    { productId, salePrice, productName, productImg, productNum = 1 }
  ) {
    const cart = state.cartList; // 购物车
    let falg = true;
    const goods = {
      productId,
      salePrice,
      productName,
      productImg,
    };
    if (cart.length) {
      // 有内容
      cart.forEach((item) => {
        if (item.productId === productId) {
          if (item.productNum >= 0) {
            falg = false;
            item.productNum += productNum;
          }
        }
      });
    }
    if (!cart.length || falg) {
      goods.productNum = productNum;
      goods.checked = '1';
      cart.push(goods);
    }
    state.cartList = cart;
    // 存入localStorage
    setStore('buyCart', cart);
  },
  // 获取购物车信息
  [INFO_CART](state, payload) {
    console.log(payload);
    state.cartInfo = payload;
    // setStore('buyCart', state.cartInfo)
  },
  // 获取站点列表
  [SITE_LIST](state, { siteList }) {
    console.log(siteList);
    state.siteList = siteList;
  },
  // 加入购物车动画
  [ADD_ANIMATION](
    state,
    {
      moveShow,
      elLeft,
      elTop,
      img,
      cartPositionT,
      cartPositionL,
      receiveInCart,
    }
  ) {
    state.showMoveImg = moveShow;
    if (elLeft) {
      state.elLeft = elLeft;
      state.elTop = elTop;
    }
    state.moveImgUrl = img;
    state.receiveInCart = receiveInCart;
    if (cartPositionT) {
      state.cartPositionT = cartPositionT;
      state.cartPositionL = cartPositionL;
    }
  },
  // 是否显示购物车
  [SHOW_CART](state, { showCart }) {
    // let timer = null
    state.showCart = showCart;
    // clearTimeout(timer)
    // if (showCart) {
    //   timer = setTimeout(() => {
    //     state.showCart = false
    //   }, 5000)
    // }
  },
  // 移除商品
  [REDUCE_CART](state, { productId }) {
    const cart = state.cartList;
    cart.forEach((item, i) => {
      if (item.productId === productId) {
        if (item.productNum > 1) {
          item.productNum--;
        } else {
          cart.splice(i, 1);
        }
      }
    });
    state.cartList = cart;
    // 存入localStorage
    setStore('buyCart', state.cartList);
  },
  // 修改购物车
  [EDIT_CART](state, { productId, productNum, checked }) {
    const cart = state.cartList;
    if (productNum) {
      cart.forEach((item) => {
        if (item.productId === productId) {
          item.productNum = productNum;
          item.checked = checked;
        }
      });
    } else if (productId) {
      cart.forEach((item, i) => {
        if (item.productId === productId) {
          cart.splice(i, 1);
        }
      });
    } else {
      cart.forEach((item) => {
        item.checked = checked ? '1' : '0';
      });
    }
    state.cartList = cart;
    // 存入localStorage
    setStore('buyCart', state.cartList);
  },
  // 修改购物车
  [EDIT_CART](state, { productId, productNum, checked }) {
    const cart = state.cartList;
    if (productNum) {
      cart.forEach((item) => {
        if (item.productId === productId) {
          item.productNum = productNum;
          item.checked = checked;
        }
      });
    } else if (productId) {
      cart.forEach((item, i) => {
        if (item.productId === productId) {
          cart.splice(i, 1);
        }
      });
    } else {
      cart.forEach((item) => {
        item.checked = checked ? '1' : '0';
      });
    }
    state.cartList = cart;
    // 存入localStorage
    setStore('buyCart', state.cartList);
  },
  // 记录用户信息
  [RECORD_USERINFO](state, { info }) {
    console.log(info);
    state.userInfo = info;
    // state.login = true
    // setStore('userInfo', info)
  },
  // 获取用户信息
  [GET_USERINFO](state, info) {
    if (state.userInfo && state.userInfo.username !== info.username) {
      return;
    }
    if (!state.login) {
      return;
    }
    if (!info.message) {
      state.userInfo = { ...info };
    } else {
      state.userInfo = null;
    }
  },
  // 获取分类列表
  [GET_PRODUCTCATEGORYLIST](state, payload) {
    state.ProductCategoryList = payload.data;
    setStore('ProductCategoryList', payload.data);
  },
  // 获取分类列表
  [GET_PRODUCTCATEGORYLISTNOLOGIN](state, payload) {
    state.ProductCategoryList = payload.data;
    setStore('ProductCategoryList', payload.data);
  },
  [CHANGE_ITEM](state, payload) {
    state.item = payload;
  },
  [GETCUSTOMER](state, payload) {
    state.getcustomer = payload;
  },
  // 改变用户信息
  [CHANGE_USERINFO](state, playload) {
    console.log(playload, 'playload');
    state.userInfo = { ...state.userInfo, ...playload };
  },
  // 记录商品列表信息
  [PRODUCT_LIST](state, payload) {
    console.log(payload, '商品信息');
    state.productList.categoryName = payload.name;
    state.productList.categoryId = payload.id;
  },
  addProductList(state, payload) {
    console.log(payload, '商品信息');
    state.productList.categoryName = payload.name;
    state.productList.categoryId = payload.id;
  },
  // 记录商品列表信息
  [PRODUCT_LIST_1](state, payload) {
    console.log(payload);
    state.productList.taxRateId = payload.tax;
    state.productList.taxRateValue = payload.taxName;
    state.productList.brandId = payload.brand;
    state.productList.brandName = payload.brandName;
    state.productList.brandNameEN = payload.brandNameEN;
    state.productList.attributeStr = payload.attributeStr;
    state.productList.attributes = payload.attributes;
    state.productList.remark = payload.remark;
    state.productList.salesScopeId = payload.salesScopeId;
    state.productList.skuFiles = payload.skuFiles;
  },
  // 记录商品列表信息
  [PRODUCT_LIST_2](state, payload) {
    console.log(payload);
    state.productList.salesScope = payload.salesScope;
  },
  // 记录属性列表信息
  [CATEGORY_LIST](state, payload) {
    console.log(payload);
    state.categoryList = payload;
  },
  // 记录商品信息
  [PRODUCT_INFO](state, payload) {
    console.log(payload);
    state.productInfo = payload;
  },
  // 记录商品信息
  [TABLE_LIST](state, payload) {
    console.log(payload);
    state.productTableList = payload;
  },

  [BRAND_INfO](state, payload) {
    state.BRANDINfO = payload;
  },
  [CREATE_PRODUCT_LIST](state, payload) {
    state.productTableList = payload;
  },
  // 按钮权限
  button_directive(state, payload) {
    state.buttonDirective = payload;
  },
  get_menuList(state, payload) {
    state.MENULIST = payload;
  },
  // 改变左边侧边栏菜单层级
  changeSider_bar(state, payload) {
    state.sider_bar = payload;
  },
  // 面包屑
  getTags_list(state, payload) {
    state.tagsList = payload;
  },
  // 用户信息
  update_userInfo(state, payload) {
    state.USERINFO = payload;
    setStore('USERINFO', JSON.stringify(payload));
  },
  update_menuInfo(state, payload) {
    state.MENUINFO = payload;
    setStore('MENUINFO', JSON.stringify(payload));
  },

  moduleBelong_tag(state, payload) {
    state.moduleBelong = payload;
  },
  getSupplierScoreInfo(state, payload) {
    state.supplierScoreInfo = payload;
  },
  // 侧边栏折叠
  [HADNDLE_COLLAPSE](state, data) {
    state.collapse = data;
  },
  // 获取采购专属商城logo
  [GET_LOGO_IMG_LIST](state, data) {
    state.logoImgList = data;
  },
  // 菜单是否打开
  getRightBar(state, payload) {
    state.isShowRightBar = payload;
  },
  // 新手引导
  [SHOW_LIB](state, payload) {
    state.showLib = payload;
  },
  // 加密路由参数
  [ROUTER_PARAMS](state, payload) {
    // state.routerParams = Base64.encode(payload);
    state.routerParams[payload.routerPath] = payload.routerParams;
  },
  // 采购产品范围
  [IS_PROTOCOL](state, payload) {
    state.isProtocol = payload;
  },
  delTagsItem(state, data) {
    state.tagsList.splice(data.index, 1);
  },
  setTagsItem(state, data) {
    state.tagsList.push(data);
  },
  clearTags(state) {
    const curItem = this.tagsList.filter((item) => {
      return item.title === '工作台';
    });
    state.tagsList = curItem;
  },
  closeTagsOther(state, data) {
    state.tagsList = data;
  },
  closeCurrentTag(state, data) {
    for (let i = 0, len = state.tagsList.length; i < len; i++) {
      const item = state.tagsList[i];
      if (item.path === data.$route.fullPath) {
        if (i < len - 1) {
          data.$router.push(state.tagsList[i + 1].path);
        } else if (i > 0) {
          data.$router.push(state.tagsList[i - 1].path);
        } else {
          data.$router.push('/');
        }
        state.tagsList.splice(i, 1);
        break;
      }
    }
  },
};
